import { IoIosClose } from 'react-icons/io';

interface Props {
  onClose: (clear?: boolean) => void;
}

export default function Modal({ onClose }: Props) {
  return (
    <div className="rb-modal-overlay">
      <div className="rb-modal rb-modal--md">
        <button className="rb-modal__close" aria-label="Fechar" onClick={() => onClose(true)}>
          <IoIosClose size={26} />
        </button>

        <div className="rb-modal__header">
          <h1 className="rb-modal__title">Ops!</h1>
        </div>

        <p className="rb-modal__text" style={{ textAlign: 'center' }}>
          Essa pessoa possui relacionamento cadastrado com você. Deseja mesmo prosseguir?
        </p>

        <div className="rb-modal__actions">
          <button
            className="rb-btn-primary"
            onClick={() => {
              onClose();
            }}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
}
